
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.092 23.77c-1.19-8.937-9.07-15.445-18.07-14.923C14.02 9.37 6.945 16.745 6.797 25.76c-.147 9.015 6.683 16.618 15.662 17.434l.238.279v1.983l-.298.298C11.684 44.883 3.612 35.636 4.196 24.9 4.78 14.165 13.807 5.848 24.554 6.144c10.747.295 19.303 9.097 19.296 19.848v1.291a19.605 19.605 0 01-2.163 6.984h-.516l-3.017-10.259.28-.358 2.658.12z","clip-rule":"evenodd"}})])
          )
        }
      }
    